import { NavLink, useLocation } from "react-router-dom";
import { Combine, FileSpreadsheet, History, ScanText, Table2, UploadCloud } from "lucide-react";
import { useLastJobId } from "@/lib/lastJob";

const items = (lastJob) => [
  { to: "/unisci", label: "Unisci File Pdf", short: "Unisci", icon: Combine, testId: "nav-merge", match: (p) => p.startsWith("/unisci") },
  { to: "/", label: "Caricamento file", short: "Carica", icon: UploadCloud, testId: "nav-upload", match: (p) => p === "/" },
  { to: lastJob ? `/tabella/${lastJob}` : "/tabella", label: "Tabella movimenti", short: "Tabella", icon: Table2, testId: "nav-table", match: (p) => p.startsWith("/tabella") },
  { to: "/storico", label: "Storico conversioni", short: "Storico", icon: History, testId: "nav-history", match: (p) => p.startsWith("/storico") },
];

const NavItem = ({ item, active }) => {
  const Icon = item.icon;
  return (
    <NavLink to={item.to} data-testid={item.testId} aria-current={active ? "page" : undefined} title={item.label}
      className={`group flex flex-col items-center gap-1 rounded-xl px-2 py-1.5 text-[10px] font-medium transition-colors sm:flex-row sm:gap-2 sm:px-3 sm:py-2 sm:text-sm lg:w-full lg:gap-3 lg:py-2.5 ${active ? "bg-emerald-500/15 text-emerald-300" : "text-slate-300 hover:bg-white/5 hover:text-white"}`}>
      <span className={`flex h-7 w-7 items-center justify-center rounded-lg transition-colors sm:h-8 sm:w-8 ${active ? "bg-emerald-500 text-slate-950" : "bg-white/5 text-slate-300 group-hover:bg-white/10"}`}>
        <Icon className="h-4 w-4" />
      </span>
      <span className="hidden whitespace-nowrap lg:inline">{item.label}</span>
      <span className="whitespace-nowrap lg:hidden">{item.short}</span>
    </NavLink>
  );
};

export const Sidebar = () => {
  const { pathname } = useLocation();
  const nav = items(useLastJobId());
  return (
    <aside data-testid="sidebar"
      className="sticky top-0 z-30 flex shrink-0 items-center gap-2 bg-slate-950 px-3 py-2 lg:h-screen lg:w-64 lg:flex-col lg:items-stretch lg:gap-0 lg:px-4 lg:py-6">
      <div className="hidden items-center gap-2 px-2 sm:flex lg:mb-10">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-500 text-slate-950">
          <ScanText className="h-5 w-5" />
        </span>
        <span className="hidden font-display text-base font-bold leading-tight text-white sm:block">
          Estratti<span className="block text-xs font-medium text-slate-400">PDF → Excel</span>
        </span>
      </div>
      <p className="hidden px-3 pb-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-500 lg:block">Menu</p>
      <nav data-testid="sidebar-nav" className="mx-auto flex gap-1 sm:ml-auto sm:mr-0 lg:ml-0 lg:flex-col lg:gap-1.5">
        {nav.map((it) => <NavItem key={it.testId} item={it} active={it.match(pathname)} />)}
      </nav>
      <div className="mt-auto hidden rounded-xl border border-white/10 p-3 text-xs text-slate-400 lg:block">
        <FileSpreadsheet className="mb-2 h-4 w-4 text-emerald-400" />
        OCR gratuito · CSV ed Excel · i file non vengono conservati
      </div>
    </aside>
  );
};
